module.exports = __webpack_public_path__ + "img/space_dust_cherry_back.d05f8089.jpg";